export const translationOrganizations_en_part3 = {
  orgDetailDeleteOrganizationConfirm: "Delete organization",
  orgDetailUnableToDeleteOrganization: "Unable to delete organization.",
  orgDetailInviteRedirectUrlLabel: "Invite Redirect URL",
  orgDetailInviteRedirectUrlHelp:
    "Users are redirected here after accepting an invitation or finishing registration. Use an approved HTTPS dashboard URL. Leave the field empty to clear it. Invitations stay blocked until a valid URL is set again.",
  orgDetailNameLabel: "Name",
  orgDetailDomainsLabel: "Domains",
  orgDetailDomainsPlaceholder: "acme.com, help.acme.com",
  orgDetailKnowledgeBaseIndexesLabel: "Knowledge Base Indexes",
  orgDetailKnowledgeBaseIndexesHelp:
    "Provide a JSON array. Each entry needs `namespace` and `index_name`. `group` is optional.",
  orgDetailCompanyInfoLabel: "Company Info",
  orgDetailAgentNameLabel: "Agent Name",
  orgDetailProductButtonTextLabel: "Product Button Text",
  orgDetailThumbsRating: "Thumbs Rating",
  orgDetailLivechat: "Livechat",
  orgDetailIntegrations: "Integrations",
  orgDetailUseBrandScope: "Use Brand Scope (internal)",
  orgDetailLivechatNotificationSound: "Livechat Notification Sound",
  orgDetailSaveSettings: "Save Settings",
  orgDetailAssignedChatbots: "Assigned Chatbots",
  orgDetailAssignedChatbotsDescription:
    "These chatbot IDs already belong to this organization. Creation and cloning live on the Chatbots tab in the Organizations view.",
  orgDetailNoChatbotsAssigned: "No chatbots assigned",
  orgDetailAssignedExclusivelyTo: "Assigned exclusively to {organization}",
  orgDetailAvailableToAttach: "Available to Attach",
  orgDetailAvailableToAttachDescription:
    "Only unassigned chatbot IDs can be attached here. Chatbots assigned to another organization are intentionally hidden.",
  orgDetailNoUnassignedChatbots:
    "No unassigned chatbot IDs are available. Create one from the Chatbot IDs page or detach an existing assignment first.",
  // Brands section (OrganizationBrandsSection.tsx)
  // Brands section (OrganizationBrandsSection.tsx)
  brandsUnableToLoad: "Unable to load brands.",
  brandsCreated: "Brand created",
  brandsCouldNotCreate: "Could not create brand.",
  brandsNameCannotBeEmpty: "Name cannot be empty.",
  brandsRenamed: "Brand renamed",
  brandsCouldNotRename: "Could not rename brand.",
  brandsDeleted: "Brand deleted",
  brandsCouldNotDelete: "Could not delete brand.",
  brandsSaved: "Saved",
  brandsCouldNotUpdateChatbot: "Could not update chatbot.",
  brandsTitle: "Brands",
  brandsIntro:
    "Group chatbots in this organization into brands. Users see brands in the scope picker when brand scope is enabled for the organization.",
  brandsListTitle: "Brand list",
  brandsTotalCount: "{count} total",
  brandsNewBrandNamePlaceholder: "New brand name",
  brandsNoBrandsYet: "No brands yet",
  brandsRenameName: "Rename {name}",
  brandsDeleteName: "Delete {name}",
  brandsChatbotAssignmentsTitle: "Chatbot assignments",
  brandsNoChatbotsInOrganization: "No chatbots in this organization",
  brandsSelectBrandPlaceholder: "Select brand",
  brandsUngrouped: "Ungrouped",
  brandsDeleteConfirmTitle: "Delete this brand?",
  brandsDeleteConfirmDescription: "Chatbots in this brand will become ungrouped.",
  orgTypeTitle: "Customer type",
  orgTypeDescription:
    "What the customer sells or does. Product analytics groups and compares customers by it. Diverge admins only; customers never see it.",
  orgTypeMain: "Main type",
  orgTypeExtra: "Extra types",
  orgTypeExtraHelp:
    "Anything else the customer sells or does, such as beauty at a fashion department store. Only filters use them.",
  orgTypeNone: "No type yet",
  orgTypeGroupShops: "Web shops",
  orgTypeGroupOther: "Not a web shop",
  orgTypeGroupExcluded: "Left out of analytics",
  orgTypePickMainFirst: "Pick a main type first",
  orgTypeNoExtra: "None",
  orgTypeSearch: "Find a type",
  orgTypeNoMatch: "No type by that name",
  orgTypeInGroup: "In the analytics group",
  orgTypeMessages: "{count} visitor messages in the last 30 days",
  orgTypeLastChange: "Changed {date} by {who}",
  orgTypeFromList: "the reviewed list",
  orgTypeNotListed: "This organization has no platform record yet, so it can't have a type.",
  orgTypeLoadError: "Could not load the customer types.",
  orgTypeSaveError: "Could not save the customer types. Try again in a moment.",
  orgTypeRetry: "Try again",
};
